import React, { useEffect } from "react"
import { useParams, useNavigate } from "react-router-dom"
import { findUser } from "../api/User/User";
import { useUserContext } from "../userContext"

function SSOLogin() {
  let { accessToken, refreshToken, email } = useParams();
  const navigate = useNavigate()
  const { setUser } = useUserContext()

  useEffect(() => {
    getUserData()
  }, [])

  const getUserData = async () => {
    if (email && email !== 'null') {
      // The axios middleware reads the token from localStorage on every request,
      // so it has to be stored before findUser is called. Otherwise the request
      // leaves without an Authorization header, comes back 401, and the user is
      // logged in with group: undefined - i.e. reduced to the lowest rights.
      localStorage.setItem("token", JSON.stringify({ accessToken: accessToken, refreshToken: refreshToken }))

      const user = await findUser(email)

      if (!user || !user.role) {
        localStorage.removeItem("token")
        navigate('/login', { state: { error: "Vos droits n'ont pas pu être récupérés, veuillez réessayer ou contacter un administrateur." } })
        return
      }

      localStorage.setItem('user', JSON.stringify({ firstName: user.firstname, lastName: user.lastname, group: user.role, email: user.email }))
      setUser({ firstName: user.firstname, lastName: user.lastname, group: user.role, email: user.email })
      navigate("/");
    } else {
      navigate('/login', { state: { error: "L'utilisateur n'a pas été crée, veuillez contacter un administrateur afin de pouvoir vous connecter à l'application hiris" } })
    }
  }

  return (<></>)
}

export default (SSOLogin)